// extracted by mini-css-extract-plugin
export default {"icon":"IsAutoSentField_icon__-4vwN"};